import React from "react";
import { Alert, AlertTitle, Snackbar, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ErrorAlert = ({ open, onClose, title, message }) => {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={6000} // Automatically hide after 6 seconds
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity="error"
        onClose={onClose}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {title && <AlertTitle>
            <Typography variant="subtitle1" fontWeight={'bold'}>{title}</Typography>
          </AlertTitle>}
        <Typography variant="body2">
        {message}
        </Typography>
      </Alert>
    </Snackbar>
  );
};

export default ErrorAlert;
